import '../app/function.js';
import '../app/validator.js';
import '../app/form.js';
import '../app/student.js';
